import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import { RequirePermission } from '@/features/auth/guards';
import { NotFoundPage } from '@/pages/not-found-page';

const SuppliersList = lazy(() => import('./pages/suppliers-list-page').then((m) => ({ default: m.SuppliersListPage })));
const SupplierDetail = lazy(() => import('./pages/supplier-detail-page').then((m) => ({ default: m.SupplierDetailPage })));
const PurchasesList = lazy(() => import('./pages/purchases-list-page').then((m) => ({ default: m.PurchasesListPage })));
const PurchaseDetail = lazy(() => import('./pages/purchase-detail-page').then((m) => ({ default: m.PurchaseDetailPage })));
const PurchaseImport = lazy(() => import('./pages/purchase-import-page').then((m) => ({ default: m.PurchaseImportPage })));

const fallback = (
  <div role="status" aria-label="Carregando" className="flex flex-col gap-3">
    {Array.from({ length: 4 }, (_, i) => (
      <div key={i} aria-hidden className="skeleton h-12 w-full" />
    ))}
  </div>
);

/** Rotas de fornecedores e compras de lote (montadas em `fornecedores/*`; a leitura é exigida em app/routes.tsx). */
export function SuppliersRoutes() {
  return (
    <Suspense fallback={fallback}>
      <Routes>
        <Route index element={<SuppliersList />} />
        <Route path="compras" element={<PurchasesList />} />
        <Route path="compras/importar" element={<RequirePermission permission={['suppliers.write']} children={<PurchaseImport />} />} />
        <Route path="compras/:id" element={<PurchaseDetail />} />
        <Route path=":id" element={<SupplierDetail />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
